import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../sections/HeroSection';
import AboutSection from '../sections/AboutSection';
import TechStackSection from '../sections/TechStackSection';
import EmbeddedSection from '../sections/EmbeddedSection';
import ExperienceSection from '../sections/ExperienceSection';
import ProjectsSection from '../sections/ProjectsSection';
import ContactSection from '../sections/ContactSection';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Zen Zalapski - Software Developer';
  }, []);

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    });
  }, [location]);

  return (
    <main className="main-content">
      <HeroSection />
      <AboutSection />
      <TechStackSection />
      <EmbeddedSection />
      <ExperienceSection />
      <ProjectsSection />
      <ContactSection />
    </main>
  );
}
